import React, { useState } from "react";
import "../../legal/PrivacyPolicy/PrivacyPolicy.css";

const Partnerships = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    partnershipType: "",
    website: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate API call
    setTimeout(() => {
      setSubmitted(true);
      setLoading(false);
    }, 1000);
  };

  if (submitted) {
    return (
      <div className="legal-page">
        <section className="legal-hero">
          <div className="container">
            <h1>Partnership Application Submitted</h1>
            <p className="legal-subtitle">
              Thank you for your interest in partnering with GoalFlex.
            </p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="deletion-success">
              <div className="success-icon">🤝</div>
              <h2>We've Received Your Application</h2>
              <p>
                Our partnerships team will review your application and respond
                within 3-5 business days. We're excited about the possibility of
                working together to grow the soccer community!
              </p>

              <div className="next-steps">
                <h3>What happens next?</h3>
                <ul>
                  <li>Our team reviews your partnership proposal</li>
                  <li>We'll schedule a discovery call if there's a good fit</li>
                  <li>We'll discuss terms and collaboration opportunities</li>
                  <li>Together we'll create a partnership agreement</li>
                </ul>
              </div>

              <div className="help-section">
                <p>
                  <strong>Questions about partnerships?</strong>
                  Email us at{" "}
                  <a href="mailto:support@goalflex.com">
                    support@goalflex.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <h1>Partnerships</h1>
          <p className="legal-subtitle">
            Join us in building the future of soccer community connection.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-intro">
            <p>
              GoalFlex is always looking for strategic partners who share our
              vision of connecting soccer players and growing the global soccer
              community. Whether you're a venue owner, sports brand, or
              technology company, we'd love to explore how we can work together.
            </p>
          </div>

          <div className="legal-section">
            <h2>Partnership Opportunities</h2>
            <div className="subsection">
              <h3>Venue Partners</h3>
              <ul>
                <li>Feature your facility on our platform</li>
                <li>Increased bookings and revenue</li>
                <li>Marketing and promotional support</li>
                <li>Revenue sharing opportunities</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Corporate Partners</h3>
              <ul>
                <li>Employee wellness programs</li>
                <li>Team building activities</li>
                <li>Corporate tournament organization</li>
                <li>Brand visibility and sponsorship</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Technology Partners</h3>
              <ul>
                <li>API integrations and data sharing</li>
                <li>Co-developed features and solutions</li>
                <li>Cross-platform user experiences</li>
                <li>Joint marketing initiatives</li>
              </ul>
            </div>
            <div className="subsection">
              <h3>Community Partners</h3>
              <ul>
                <li>Local soccer clubs and organizations</li>
                <li>Youth development programs</li>
                <li>Coaching and training partnerships</li>
                <li>Event and tournament collaboration</li>
              </ul>
            </div>
          </div>

          <div className="legal-section">
            <h2>Why Partner with GoalFlex?</h2>
            <ul>
              <li>
                <strong>Growing Network:</strong> 500+ active players across
                Minnesota and expanding
              </li>
              <li>
                <strong>Engaged Community:</strong> 25+ games organized weekly
              </li>
              <li>
                <strong>Professional Platform:</strong> Modern technology and
                user experience
              </li>
              <li>
                <strong>Local Focus:</strong> Deep roots in Minnesota soccer
                communities
              </li>
              <li>
                <strong>Rapid Growth:</strong> New startup with ambitious
                expansion plans
              </li>
              <li>
                <strong>Shared Values:</strong> Commitment to building inclusive
                soccer communities
              </li>
            </ul>
          </div>

          <div className="deletion-form-section">
            <h2>Partnership Application</h2>
            <form onSubmit={handleSubmit} className="deletion-form">
              <div className="form-group">
                <label htmlFor="name">Contact Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Company/Organization *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="form-input"
                  value={formData.company}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="website">Website</label>
                <input
                  type="url"
                  id="website"
                  name="website"
                  className="form-input"
                  placeholder="https://your-website.com"
                  value={formData.website}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="partnershipType">Partnership Type *</label>
                <select
                  id="partnershipType"
                  name="partnershipType"
                  className="form-select"
                  value={formData.partnershipType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select partnership type...</option>
                  <option value="venue">Venue Partner</option>
                  <option value="corporate">Corporate Partner</option>
                  <option value="technology">Technology Integration</option>
                  <option value="community">Community Organization</option>
                  <option value="brand">Brand/Sponsorship</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Partnership Proposal *</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  placeholder="Tell us about your organization and how you'd like to partner with GoalFlex. Include details about your goals, what you can offer, and what you're looking for..."
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  required
                />
                <p className="form-help">
                  Please be as detailed as possible about your partnership
                  vision.
                </p>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="btn-delete"
                  disabled={loading}
                  style={{
                    background: loading
                      ? "#6b7280"
                      : "linear-gradient(135deg, #10b981, #059669)",
                    transform: "none",
                  }}
                >
                  {loading ? "Submitting..." : "Submit Partnership Application"}
                </button>

                <div className="alternative-actions">
                  <p>
                    <strong>Have questions?</strong>
                    <a href="mailto:support@goalflex.com">
                      Email support@goalflex.com
                    </a>
                  </p>
                  <p>
                    <strong>General inquiries?</strong>
                    <a href="mailto:support@goalflex.com">Contact Support</a>
                  </p>
                </div>
              </div>
            </form>
          </div>

          <div className="legal-section">
            <h2>Current Partners</h2>
            <p>
              As a growing startup, we're actively building partnerships with
              local organizations in the Minnesota soccer community:
            </p>
            <ul>
              <li>
                <strong>Local Soccer Facilities:</strong> Building our venue
                partner network
              </li>
              <li>
                <strong>Minnesota Soccer Clubs:</strong> Community development
                partnerships
              </li>
              <li>
                <strong>Twin Cities Businesses:</strong> Corporate wellness
                pilot programs
              </li>
              <li>
                <strong>Sports Technology Partners:</strong> Payment and
                platform integrations
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Contact Our Partnerships Team</h2>
            <div className="contact-info">
              <p>
                <strong>Partnerships Email:</strong>{" "}
                <a href="mailto:support@goalflex.com">
                  support@goalflex.com
                </a>
              </p>
              <p>
                <strong>Business Development:</strong>{" "}
                <a href="mailto:support@goalflex.com">support@goalflex.com</a>
              </p>
              <p>
                <strong>Phone:</strong>{" "}
                <a href="tel:+16121234567">+1 (612) 123-4567</a>
              </p>
              <p>
                <strong>Location:</strong> Minneapolis, Minnesota
              </p>
              <p>
                <strong>Response Time:</strong> We respond to all partnership
                inquiries within 2-3 business days
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partnerships;
